/**
 * @class
 * @function FreeGiftCart
 * Tilføjer/fjerner gaveproduktet async og re-renderer hele
 * cart draweren uden refresh (draweren er en snippet, så vi
 * henter frisk HTML fra siden og swapper indholdet).
 */

if (!customElements.get('free-gift-cart')) {
  class FreeGiftCart extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-fgc-add]')?.addEventListener('click', () => {
        this.mutateCart('/cart/add.js', {
          items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
        });
      });

      this.querySelector('[data-fgc-remove]')?.addEventListener('click', () => {
        this.mutateCart('/cart/change.js', {
          id: this.dataset.giftLineKey,
          quantity: 0,
        });
      });
    }

    async mutateCart(endpoint, payload) {
      const btn = this.querySelector('[data-fgc-add], [data-fgc-remove]');
      this.setLoading(btn, true);

      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error(`Cart request failed (${res.status})`);
        await res.json();

        await this.refreshDrawer();
        this.notifyTheme();
      } catch (err) {
        console.error('[FreeGiftCart]', err);
        this.setLoading(btn, false);
      }
      // Ingen setLoading(false) ved succes – knappen bliver
      // udskiftet sammen med resten af draweren.
    }

    /**
     * Henter siden i baggrunden og udskifter drawerens indhold
     * med den friske version. Kun .side-panel-inner swappes,
     * så draweren forbliver åben.
     */
    async refreshDrawer() {
      const res = await fetch(window.location.pathname, {
        headers: { Accept: 'text/html' },
        cache: 'no-store',
      });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const freshInner = doc.querySelector('#Cart-Drawer .side-panel-inner');
      const currentInner = document.querySelector('#Cart-Drawer .side-panel-inner');

      if (freshInner && currentInner) {
        currentInner.replaceWith(freshInner);
      }

      // Opdater evt. cart-count i headeren udenfor draweren
      this.syncCartCount(doc);
    }

    syncCartCount(doc) {
      const selectors = ['.cart-count', '[data-cart-count]', '.header-cart sup'];
      selectors.forEach((sel) => {
        const fresh = doc.querySelector(sel);
        const current = document.querySelector(sel);
        if (fresh && current) current.textContent = fresh.textContent;
      });
    }

    notifyTheme() {
      ['cart:refresh', 'cart:change', 'theme:cart:change'].forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
    }

    setLoading(btn, loading) {
      if (!btn) return;
      btn.disabled = loading;
      const spinner = btn.querySelector('.fgc__spinner');
      const label = btn.querySelector('.fgc__add-label');
      if (spinner) spinner.hidden = !loading;
      if (label) label.style.opacity = loading ? '.5' : '1';
    }
  }
  customElements.define('free-gift-cart', FreeGiftCart);
}